"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MinimizeOutlineSVG = void 0;
var _react = _interopRequireDefault(require("react"));
var _logging = require("../../../util/logging");
var _IconCollapseOutline = _interopRequireWildcard(require("./IconCollapseOutline"));
// eslint-disable-next-line zillow/import/no-named-default

var MinimizeOutlineSVG = _IconCollapseOutline.CollapseOutlineSVG;
exports.MinimizeOutlineSVG = MinimizeOutlineSVG;
var MinimizeOutline = function MinimizeOutline(props) {
  (0, _logging.logDeprecation)("`IconMinimizeOutline` has been deprecated, use `IconCollapseOutline`");
  return /*#__PURE__*/_react.default.createElement(_IconCollapseOutline.default, props);
};
MinimizeOutline.displayName = 'IconMinimizeOutline';
var _default = MinimizeOutline;
exports.default = _default;